module.exports = __webpack_public_path__ + "static/media/team-swimmy-diego.a44ffe03.png";